'use client'

import { useEffect } from 'react'
import { useSignIn } from '@clerk/nextjs/legacy'

export function Session({ sessionId }: { sessionId?: string | null }) {
  const { setActive } = useSignIn()

  useEffect(() => {
    if (sessionId) {
      setActive?.({ session: sessionId })
    }
  }, [sessionId, setActive])

  return null
}
